import WORLD from "../../../data/world.json" with { type: "json" };
import { Feature } from "../types/Feature.js";
import { withModifier } from "../../engine/tiles.js";

const mod = (a, n) => ((a % n) + n) % n;

// A rigid lattice of interconnected rooms — walls every `fortressCell` tiles,
// obviously artificial next to the noise terrain. Now that platforms are solid, doors
// keep every room reachable: a two-tall doorway at the base of each vertical wall lets
// you walk between side-by-side rooms, and a one-wide gap in each horizontal wall lets
// you climb or drop between stacked ones. Corner posts (where a vertical and a
// horizontal wall cross) stay solid. Not every wall side gets a door, but the openings
// connect the whole lattice, so no room is sealed off.
export class FortressFeature extends Feature {
    getTile(api, tcx, tri) {
        const c = WORLD.features.fortressCell;
        const cm = mod(tcx, c), rm = mod(tri, c);
        const vWall = cm === 0, hWall = rm === 0;
        if (!vWall && !hWall) return undefined; // open room interior: air

        const base = api.getBiomeBaseTile();
        const door = (open) => withModifier(base, open ? "doorOpen" : "doorClosed");
        // A doorway at the two tiles just above a floor -> walk between neighbours. The
        // two tiles share one roll (keyed on the column + floor) so the doorway is fully
        // open or fully shut, never half. Most start closed; you open them to pass.
        if (vWall && !hWall && (rm === c - 1 || rm === c - 2)) return door(api.doorOpen(tcx, Math.floor(tri / c)));
        // A gap at mid-span of a horizontal wall -> a way up or down between floors.
        if (hWall && !vWall && cm === (c >> 1)) return door(api.doorOpen(tcx, tri));
        return base; // solid wall
    }
}
